// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3PYRI","header":"ReportDetails_header__24Fk1","title":"ReportDetails_title__3UQ-4","left":"ReportDetails_left__3jdqM"};